module.exports = __webpack_public_path__ + "static/media/tanveer.2c53c445.png";